/* Garde d'idempotence : selon le noeud CDN, ce code arrive soit inline dans la section,
   soit par le fichier asset. Les deux peuvent charger — seul le premier s'initialise. */
if (!window.__vyrCartInit) {
  window.__vyrCartInit = true;

  (function () {
    var LOCK = 'vyrc-locked';
    var KEY = 'vyrCartUntil';
    var SPAN = 10 * 60 * 1000;
    var refreshing = false;
    var memo = 0; /* repli quand sessionStorage est bloqué (Safari navigation privée) */

    function readUntil() {
      try { return parseInt(window.sessionStorage.getItem(KEY) || '0', 10); }
      catch (e) { return memo; }
    }

    function writeUntil(v) {
      memo = v;
      try { window.sessionStorage.setItem(KEY, String(v)); } catch (e) {}
    }


    /* Un pack de N unités part en N lignes distinctes de la variante à l'unité.
       C'est ce qui donne N produits au checkout et déclenche la remise automatique
       « 2 VYRAN + 1 FREE » de Shopify, visible dans le panier. */
    function multiPack(form) {
      try {
        var checked = form.querySelector('[data-vyr-packs] input[type="radio"]:checked');
        if (!checked) return null;
        var label = checked.closest('[data-vyr-pack]');
        var units = parseInt(label && label.getAttribute('data-vyr-units'), 10) || 1;
        if (units < 2) return null;

        var mapEl = form.querySelector('[data-vyr-unitmap]');
        if (!mapEl) return null;
        var map = JSON.parse(mapEl.textContent);

        var rows = label.querySelectorAll('.vyr-pack__sizerow');
        var items = [];
        for (var i = 0; i < rows.length; i++) {
          var color = rows[i].querySelector('.vyr-select--color');
          var selects = rows[i].querySelectorAll('.vyr-select');
          var size = selects[selects.length - 1];
          var key = (color ? color.value : '') + '||' + (size ? size.value : '');
          var id = map[key];
          if (!id) return null; /* combinaison inconnue : on retombe sur le comportement normal */
          items.push({ id: id, quantity: 1 });
        }
        return items.length === units ? { items: items } : null;
      } catch (err) {
        return null;
      }
    }

    function root() { return document.querySelector('[data-vyrc]'); }

    function open() {
      var r = root();
      if (!r) return;
      r.hidden = false;
      document.body.classList.add(LOCK);
      window.setTimeout(function () {
        var cur = root();
        if (cur) cur.classList.add('is-open');
      }, 10);
    }

    function close() {
      var r = root();
      if (!r) return;
      r.classList.remove('is-open');
      document.body.classList.remove(LOCK);
      window.setTimeout(function () {
        var cur = root();
        if (cur && !cur.classList.contains('is-open')) cur.hidden = true;
      }, 260);
    }

    function tick() {
      var el = document.querySelector('[data-vyrc-clock]');
      if (!el) return;
      var until = readUntil();
      if (!until || until < Date.now()) {
        until = Date.now() + SPAN;
        writeUntil(until);
      }
      var left = Math.max(0, until - Date.now());
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }
    window.setInterval(function () { try { tick(); } catch (e) {} }, 1000);

    /* On ne touche jamais au contenu de cart-icon : Horizon y attend un ref nommé et
       l'écraser fait planter tout son système de composants, donc l'ajout au panier.
       On remplace l'élément entier par celui du rendu serveur, refs compris. */
    function syncCount(doc) {
      try {
        var fresh = doc.querySelector('cart-icon');
        var cur = document.querySelector('cart-icon');
        if (fresh && cur) cur.replaceWith(fresh.cloneNode(true));
      } catch (e) {}
    }

    function refresh(thenOpen) {
      if (refreshing) {
        if (thenOpen) open();
        return Promise.resolve();
      }
      refreshing = true;
      return fetch(window.location.pathname + window.location.search, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-vyrc]');
          var cur = root();
          if (next && cur) {
            var wasOpen = cur.classList.contains('is-open');
            next.hidden = wasOpen ? false : cur.hidden;
            if (wasOpen) next.classList.add('is-open');
            cur.replaceWith(next);
          }
          syncCount(doc);
          tick();
          if (thenOpen) open();
        })
        .catch(function () { if (thenOpen) open(); })
        .then(function () { refreshing = false; });
    }

    /* Le bouton panier de Horizon n'est pas un lien : c'est un <button aria-label="Cart">
       câblé sur son propre drawer, que nous avons supprimé. On l'attrape par tous ses signes. */
    function cartTrigger(target) {
      var t = target.closest('a[href$="/cart"], a[href*="/cart?"], [aria-label="Cart"], [data-testid="cart-icon"]');
      if (t) return t;
      var icon = target.closest('cart-icon');
      if (icon) return icon.closest('button, a') || icon;
      /* Horizon enveloppe <cart-icon> dans un <button> : un clic sur la marge du bouton
         ne remonte à rien par closest(). Au doigt, la marge est l'essentiel de la cible. */
      var btn = target.closest('button, a');
      if (btn && btn.querySelector('cart-icon')) return btn;
      return null;
    }

    document.addEventListener('click', function (e) {
      try {
        if (e.target.closest('[data-vyrc-close]')) {
          e.preventDefault();
          close();
          return;
        }

        if (root() && cartTrigger(e.target)) {
          e.preventDefault();
          e.stopPropagation();
          open();
          return;
        }

        var atc = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button:not([type])');
        if (atc) {
          var form = atc.closest('form');
          e.preventDefault();
          e.stopPropagation();
          atc.setAttribute('aria-busy', 'true');
          var payload = multiPack(form);
          var req = payload
            ? fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(payload)
              })
            : fetch('/cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
          req.then(function (r) { return r.json(); })
            .then(function () { return refresh(true); })
            .catch(function () {})
            .then(function () { atc.removeAttribute('aria-busy'); });
          return;
        }

        var step = e.target.closest('[data-vyr-qty]');
        if (step) {
          e.preventDefault();
          e.stopPropagation();
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              line: parseInt(step.dataset.vyrQty, 10),
              quantity: parseInt(step.dataset.vyrTo, 10)
            })
          }).then(function () { return refresh(false); }).catch(function () {});
        }
      } catch (err) {
        /* jamais bloquer le clic à cause d'une erreur de notre côté */
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Les sections qui construisent elles-mêmes leur payload (buy box crème) ont besoin
       d'ouvrir le tiroir sans passer par l'interception de formulaire. */
    window.vyrCart = { open: open, close: close, refresh: refresh };

    try { tick(); } catch (e) {}
  })();
}
